/*
 * コンサルタント案件提案（api update）
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_UPDATE_PROFESSIONAL_RFP_OFFER_SAVE = 'API_UPDATE_PROFESSIONAL_RFP_OFFER_SAVE';
export const API_UPDATE_PROFESSIONAL_RFP_OFFER_DRAFT = 'API_UPDATE_PROFESSIONAL_RFP_OFFER_DRAFT';
export const API_UPDATE_PROFESSIONAL_RFP_OFFER_LOCK = 'API_UPDATE_PROFESSIONAL_RFP_OFFER_LOCK';
/**
 * コンサルタント案件提案 提案内容提出
 * @param data
 * @param meta
 * @returns
 */
export const apiUpdateRfpOfferSave = ({ json, path: { id, lock_id: lockId } }, meta) => apiUpdate(API_UPDATE_PROFESSIONAL_RFP_OFFER_SAVE, `/professional/rfp/${id}/offer/${lockId}/save`, json, Object.assign(Object.assign({}, meta), { isSnakeCase: true, requestPayload: { id, lock_id: lockId } }));
/**
 * コンサルタント案件提案 下書き保存
 * @param data
 * @param meta
 * @returns
 */
export const apiUpdateRfpOfferDraft = ({ json, path: { id, lock_id: lockId } }, meta) => apiUpdate(API_UPDATE_PROFESSIONAL_RFP_OFFER_DRAFT, `/professional/rfp/${id}/offer/${lockId}/draft`, json, Object.assign(Object.assign({}, meta), { isSnakeCase: true, requestPayload: { id, lock_id: lockId } }));
/**
 * コンサルタント案件提案 編集状態更新
 * @param data
 * @param meta
 * @returns
 */
export const apiUpdateRfpOfferLock = ({ path: { id, lock_id: lockId } }, meta) => apiUpdate(API_UPDATE_PROFESSIONAL_RFP_OFFER_LOCK, `/professional/rfp/${id}/offer/${lockId}/lock`, {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true, requestPayload: { id, lock_id: lockId } }));
